import LocalizedStrings from 'react-localization';

import { UILocalizationENUS } from './en-US';
import { UILocalizationENCA } from './en-CA';
import { UILocalizationFRCA } from './fr-CA';

// Custom strings used for non-DB fields.
export const strings = new LocalizedStrings({ 'en-US': UILocalizationENUS });

// Dynamically load other locales if needed.
export const setLocale = (locale: string) => {
    if (locale === 'en-CA') {
        /* webpackChunkName: "enCALocale" */
        // const holdResult = await import('./en-CA');
        // DBLocaleStrings.setContent({ 'en-CA': holdResult.ReyDRLocalizationsENCA });
        // strings.setContent({'en-CA': holdResult.UILocalizationENCA});
        strings.setContent({ 'en-CA': UILocalizationENCA });
    } else if (locale === 'fr-CA') {
        /* webpackChunkName: "frCALocale" */
        // const holdResult = await import('./fr-CA');
        // DBLocaleStrings.setContent({ 'fr-CA': holdResult.ReyDRLocalizationsFRCA });
        // strings.setContent({'fr-CA': holdResult.UILocalizationFRCA});
        strings.setContent({ 'fr-CA': UILocalizationFRCA });
    } else {
        // DBLocaleStrings.setContent({ 'en-US': ReyDRLocalizationsENUS });
        strings.setContent({'en-US': UILocalizationENUS});
    }
};

// Export with supported locales.
export const locales = {
    'en-US': 'enUS',
    'en-CA': 'enCA',
    'fr-CA': 'frCA',
};